import Vue from 'vue'
import App from './App.vue'

//ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'echarts/map/js/china'
// 引入echarts
import echarts from 'echarts'
//路由
import router from '@/router/index'


Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(router);

new Vue({
    render: h => h(App),
    router,
}).$mount('#app');
